import $ from 'jquery';
import Breakpoints from 'breakpoints-js';
import {autocomplete} from '@algolia/autocomplete-js';
import {getRecentSearchesPlugin} from './plugins/plugin.recentSearches';
import {getQuerySuggestionsPlugin} from './plugins/plugin.querySuggestions';
import {getBannersPlugin} from './plugins/plugin.banners';

function simpleDebounce(func, timeout = 300) {
    let timer;
    return (...args) => {
        clearTimeout(timer);
        timer = setTimeout(() => {
            func.apply(this, args);
        }, timeout);
    };
}

function conditionallyRemoveGenderFilter(search, translations) {
    var currURL = window.location.href; //get current address
    if (search.renderState[ACC.config.algolia.index].stats.nbHits === 0 &&
        currURL.includes('query')) {
        if (currURL.includes('departmentName')) {
            //in case no result, remove the department filter
            search.helper.removeDisjunctiveFacetRefinement('departmentName');
            search.refresh();
        } else {
            //in case no result without department filter, put back the filter, but DO NOT Refresh!
            search.helper.addDisjunctiveFacetRefinement('departmentName',
                [translations['algolia.search.preselect.' + sessionStorage.getItem('genderPreSelection')]]);
        }
    }
}

function debouncePromise(fn, time) {
    let timerId = undefined;

    return function debounced(...args) {
        if (timerId) {
            clearTimeout(timerId);
        }

        return new Promise((resolve) => {
            timerId = setTimeout(() => resolve(fn(...args)), time);
        });
    };
}

const debounced = debouncePromise((items) => Promise.resolve(items), ACC.config.algolia.debounceMillisSuggestion);

const getAutoComplete = (instantSearchRouter, searchClient, searchPageState, setInstantSearchUiState, debouncedSetInstantSearchUiState, getSkipInstantSearchUiStateUpdate, setSkipInstantSearchUiStateUpdate, translations, settings) => {

    return autocomplete({
        ...settings,
        openOnFocus: true,
        insights: true, //{userToken: window.algoliaUserToken}
        placeholder: translations['algolia.search.placeholder'],
        classNames: {
            form: 'c-main-search__form',
            input: 'c-main-search__input text-truncate form-control',
            submitButton: 'c-main-search__btn btn btn-search js_search_button'
        },
        plugins: [getRecentSearchesPlugin(translations), getQuerySuggestionsPlugin(searchClient, translations), getBannersPlugin(searchClient)],
        getSources({query}) {
            return debounced([]);
        },
        render({elements, render, html}, root) {
            const {recentSearchesPlugin, querySuggestionsPlugin, bannersPlugin} = elements;

            render(
                html`
                    <div class="aa-PanelLayout aa-Panel--scrollable">
                        <div class="aa-PanelSections row">
                            <div class="aa-PanelSection--left col-12 col-md-6"
                                 style="${recentSearchesPlugin === undefined ? 'diplay:none' : ''}">
                                ${recentSearchesPlugin}
                            </div>
                            <div class="aa-PanelSection--right col-12 ${recentSearchesPlugin === undefined ? '' : 'col-md-6'}">
                                ${querySuggestionsPlugin}
                            </div>
                        </div>
                        <div class="aa-PanelSections row">
                            <div class="aa-PanelSection--banner col-12">
                                ${bannersPlugin}
                            </div>
                        </div>
                    </div>`,
                root
            );
        },
        detachedMediaQuery: 'none',
        initialState: {
            query: typeof (searchPageState.query) === 'string' ? searchPageState.query : '',
        },
        onSubmit({state}) {
            let preselect = {};
            let query = '';

            if (Breakpoints.is('xs') || Breakpoints.is('sm')) {
                query = $('.c-main-search.mobile .c-main-search__input').val();
            } else {
                query = $('.c-main-search.desktop .c-main-search__input').val();
            }

            if (sessionStorage.getItem('genderPreSelection') !== undefined && sessionStorage.getItem('genderPreSelection') !== '') {
                preselect = {
                    refinementList: {
                        departmentName: [translations['algolia.search.preselect.' + sessionStorage.getItem('genderPreSelection')]]
                    },
                };
            }

            let nextState = {
                query: query,
                ...preselect
            };

            if ($('body').hasClass('template-pages-search-searchListPage')) {
                setInstantSearchUiState(nextState);
            } else {
                const url = instantSearchRouter.createURL({['']: nextState});
                const urlArray = url.split('?');

                window.location = $('.c-main-search').attr('data-search-url') + '?' + urlArray[1];
            }
        },
        onReset() {
            if ($('body').hasClass('template-pages-search-searchListPage') || $('body').hasClass('template-pages-category-productListPage')) {
                setInstantSearchUiState({query: ''});
            }
        },
        // onStateChange({prevState, state}) {
        //     if ($('body').hasClass('template-pages-search-searchListPage')) {
        //         if (!getSkipInstantSearchUiStateUpdate() && prevState.query !== state.query) {
        //             debouncedSetInstantSearchUiState({query: state.query});
        //         }
        //         setSkipInstantSearchUiStateUpdate(false);
        //     }
        // }
    });
};

export {getAutoComplete, simpleDebounce, conditionallyRemoveGenderFilter};